import type { Membership } from '@bambi/api-client/schemas';

import { getCachedMembership } from '../trip.slice';
import { useAppSelector } from 'src/app/store/hooks';

export function CreatedByCell({ id }: { id: string | null }) {
  const cachedMembership = useAppSelector((state) =>
    getCachedMembership(state, id || '')
  ) as Membership | undefined;

  if (!cachedMembership) {
    return <>Unknown</>;
  }

  return (
    <>
      {cachedMembership.first_name} {cachedMembership.last_name}
    </>
  );
}
